import React from 'react';
import PropTypes from 'prop-types';

// import CircleCheck from '../icons/CircleCheck';

const EmbedInput = ({
  disabled,
  handleChange,
  handleSubmit,
  name,
  value,
}) => (
  <form className="embed-input" disabled={disabled} onSubmit={handleSubmit} data-testid="embed-input-form">
    {/*
    TODO: add back to design as part of ENGA-828
    <div className="embed-input__icon">
      <CircleCheck />
    </div> */}
    <input
      className="embed-input__field"
      disabled={disabled}
      name={name}
      onChange={handleChange}
      placeholder="Paste URL here"
      type="text"
      value={value}
    />
    <input className="embed-input__button" disabled={disabled} type="submit" value="Upload" />
  </form>
);

EmbedInput.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default EmbedInput;
